import {combineReducers} from '@modifi/redux'

import registrationNumbersReducer from './company-profile/registration-numbers/reducer'
import beneficialOwnersReducer from './company-profile/beneficial-owners/reducer'
import directDebitAccountReducer from './company-profile/direct-debit-account/reducer'
import legalRepresentativesReducer from './company-profile/legal-representatives/reducer'
import directorsReducer from './company-profile/directors/reducer'
import sellerBankAccountsReducer from './company-profile/seller-bank-accounts/reducer'
import sellerTradePartnersReducer from './seller-trade-partners/reducer'
import dataImportReducer from './intro/data-source-wizard/reducer'
import shareholdingCompanyReducer from './company-profile/intermediary-shareholders/store'
import shareholderConfirmationReducer from './company-profile/intermediary-shareholders/dialogs/company-confirmation-dialog/store'
import preUnderwritingReducer from './intro/pre-underwriting-form/reducer'
import companyFinancialDocsReducer from './company-documents/financial-documents/store'
import groupFinancialDocsReducer from './company-documents/group-financial-documents/store'

export default combineReducers({
  registrationNumbers: registrationNumbersReducer,
  sellerBankAccounts: sellerBankAccountsReducer,
  legalRepresentatives: legalRepresentativesReducer,
  directors: directorsReducer,
  beneficialOwners: beneficialOwnersReducer,
  sellerTradePartners: sellerTradePartnersReducer,
  dataImport: dataImportReducer,
  directDebitBankAccount: directDebitAccountReducer,
  intermediaryShareholder: shareholdingCompanyReducer,
  intermediaryShareholderConfirmation: shareholderConfirmationReducer,
  preUnderwriting: preUnderwritingReducer,
  yearlyClosingCompany: companyFinancialDocsReducer,
  yearlyClosingGroup: groupFinancialDocsReducer,
})
